/**
 * Summary  The component to Check Document info view
 *
 * @file    This file define Check Document info Component as class
 * @author  Alejandro Jimenez Mateus.
 * @since   2019-05-29
 */
import { Component } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { DocumentModel } from '../../../shared/models/document.model';
import { LogDeviceModel } from '../../../shared/models/log-device.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-check-document-info',
  templateUrl: './check-document-info.component.html',
  styleUrls: ['./check-document-info.component.scss'],
})
export class CheckDocumentInfoComponent {
  active_face: boolean;
  documentInfo: DocumentModel;
  productSelected: IProductsModel;
  devicePrint: LogDeviceModel;
  /**
   * Summary Initialize Services
   * @param navigationService
   */
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private captureService: CaptureService,
    private bioCatchService: BioCatchService,
    private parametersService: ParametersService,
    private headerService: HeaderService,
    private taggingService: TaggingService,
    private bitacoraService: BitacoraService,
  ) {
    this.devicePrint = new LogDeviceModel();
    this.active_face = true;
    this.headerService.show(true, true, true);
  }

  /**
   * Change document view versus reverse
   */
  changeviewDocument() {
    this.active_face = !this.active_face;
    const category = {
      module: 'body',
      type: 'button',
      position: 'center',
    };
    if (!this.active_face) {
      this.pageTagEvent('6', category, 'click', 'VerificarDatoReverso');
    } else {
      this.pageTagEvent('7', category, 'click', 'VerificarDatoFrontal');
    }
  }

  /**
   * Event click next screen
   */
  next() {
    const bitacoraEvent = 'client_verify_document';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.productSelected = this.abreCuentasService.getproductSelected();
    console.warn('productSelected---', this.abreCuentasService.getProductsSelects());
    // if (this.abreCuentasService.getProductsSelects()[0].flow === 'loan') {
    //   this.navigationService.nextStep('300');
    // } else {
    if (this.productSelected.code === '201') {
      console.log('aquiii...........', this.productSelected);

      const occupation = this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0];
      this.abreCuentasService.setOccupationSelected(occupation);
      this.captureService.sendProspectOccupation().then(
        (res: any) => {
          if (!res) { return; }
          let nextCode: string = undefined as any;
          this.abreCuentasService.setinfoInferredIncomes(res.body.data);
          if (!res.status || res.status === 500) {
            this.navigationService.navigateToGeneralInformation('500');
          } else if (res.statusCode !== 200) {
            const codigo = res.body.data.codigo;
            switch (codigo) {
              case '422-06':
                nextCode = '106';
                break;
              case '422-07':
                nextCode = '106';
                break;
              case '400':
                nextCode = '500';
                break;
            }
            this.abreCuentasService.caseInfoError(nextCode);
            this.navigationService.nextStep(nextCode);
          } else {
            this.navigationService.nextStep(nextCode);
          }
        }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
    } else if (this.abreCuentasService.getSolicitationId() !== '') {
      this.navigationService.nextStep('204');
    } else {
      this.navigationService.nextStep();
    }
    // }

  }

  /**
   * @author cramos
   * @param eventNumber id number of event 1/2/3/4
   * @param category object with properties see eventCategories variable
   * @param customAction action of event click/show
   */
  pageTagEvent(eventNumber: string, category: any, customAction: string, customLabel: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
        {
          path:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction[customAction],
        label: customLabel,
      };

      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }
}
